import { cn } from "@/lib/utils";

interface LogoStripProps {
  companies: string[];
  className?: string;
}

const LogoStrip = ({ companies, className }: LogoStripProps) => {
  // Duplicate for seamless loop
  const duplicatedCompanies = [...companies, ...companies];

  return (
    <section className={cn("py-16 relative overflow-hidden", className)}>
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-card/50 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        <p className="text-center text-sm text-muted-foreground mb-10">
          Trusted by leaders at industry-leading companies
        </p>

        {/* Marquee container */}
        <div className="relative">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

          {/* Scrolling logos - pure CSS animation */}
          <div className="flex gap-16 items-center animate-marquee hover:[animation-play-state:paused]">
            {duplicatedCompanies.map((company, index) => (
              <div
                key={`${company}-${index}`}
                className="flex-shrink-0 group cursor-default"
              >
                <div className="relative px-8 py-4 rounded-xl border border-border/50 bg-card/30 backdrop-blur-sm transition-all duration-300 hover:border-primary/30 hover:bg-card/60">
                  <span className="text-xl md:text-2xl font-bold text-muted-foreground group-hover:text-muted-foreground transition-colors duration-300 whitespace-nowrap">
                    {company}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoStrip;
